import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/settings/users/store/userSlice/initialState.ts'
import { User } from '@/modules/settings/users/types/User.ts'

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const userActions = userSlice.actions
export const { reducer: userReducer } = userSlice
